export default class Enums {
  public static getKey<T extends { [index: string]: string }>(
    enumType: T,
    enumValue: string
  ): keyof T | null {
    const keys = Object.keys(enumType).filter((x) => enumType[x] === enumValue);
    return keys.length > 0 ? keys[0] : null;
  }
}
